import { BrowserRouter } from "react-router-dom";
import "antd/dist/reset.css";
import "react-phone-number-input/style.css";
import "react-loading-skeleton/dist/skeleton.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Router from "./routes/router";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_SERVERID } from "./helpers/constants";

const queryClient = new QueryClient();

const AppWrapper = () => <App />;

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <GoogleOAuthProvider clientId={GOOGLE_SERVERID || ""}>
          <Router />
        </GoogleOAuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default AppWrapper;
